import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './components/App';
import { ConfirmDialogProvider } from './components/AlertDialogModal';

const container = document.getElementById('root')!;
const root = createRoot(container);


root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ConfirmDialogProvider>
      <App/>
    </ConfirmDialogProvider>
  </Provider>
  // </React.StrictMode>
);
